var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2005_3766",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 26,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12219 0.000244141H32.7802V29.9385H7.12219V0.000244141Z",
    className: "basecolor3Fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2005_3766)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8854 29.9385C13.9069 29.9385 10.1665 28.3814 7.35294 25.5541C7.04528 25.2449 7.04528 24.7414 7.35294 24.432C7.50196 24.2822 7.70009 24.1997 7.91122 24.1997C8.12211 24.1997 8.32048 24.2822 8.4695 24.432C10.3376 26.3099 12.6955 27.5764 15.2875 28.0947C16.1409 28.2652 17.0146 28.3516 17.8844 28.3516C19.642 28.3516 21.3566 28.0088 22.9806 27.3331C25.4217 26.3172 27.4883 24.6127 28.9568 22.4041C30.4251 20.196 31.2012 17.6249 31.2012 14.9694C31.2012 12.3135 30.4251 9.74265 28.9568 7.53475C27.4885 5.32636 25.422 3.62217 22.9806 2.6058C21.3568 1.92983 19.6425 1.58701 17.8851 1.58701C17.0151 1.58701 16.1409 1.67386 15.2875 1.84443C12.6957 2.36265 10.3381 3.62894 8.4695 5.50709C8.32048 5.65685 8.12211 5.73935 7.91122 5.73935C7.70009 5.73935 7.50196 5.65685 7.35294 5.50709C7.04528 5.19741 7.04528 4.69394 7.35294 4.38475C9.19991 2.52886 11.5088 1.18927 14.0299 0.510395C15.2868 0.171685 16.5839 0.000152588 17.8851 0.000152588C19.1861 0.000152588 20.4832 0.171685 21.7401 0.510395C24.2616 1.18927 26.5706 2.52886 28.4173 4.38475C31.2308 7.21177 32.7802 10.9712 32.7802 14.9697C32.7802 18.9677 31.2311 22.7266 28.4175 25.5541C25.6042 28.3814 21.8638 29.9385 17.8854 29.9385Z",
    className: "color3Fill"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1571 20.9385C22.9323 20.9385 22.7208 20.8592 22.5617 20.7151L17.2472 15.8912C17.0902 15.7489 17 15.5516 17 15.3503V5.70381C17 5.28187 17.3783 4.93854 17.8429 4.93854C18.3077 4.93854 18.6858 5.28187 18.6858 5.70381V15.0338L23.7533 19.6328C23.9124 19.7772 24 19.9694 24 20.174C24 20.3783 23.9124 20.5702 23.7533 20.7146C23.594 20.859 23.3822 20.9385 23.1571 20.9385Z",
    className: "color3Fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.817598 15.9385C0.366673 15.9385 0 15.4898 0 14.9387C0 14.3872 0.366673 13.9385 0.817598 13.9385H11.1827C11.3978 13.9385 11.6087 14.0455 11.7607 14.2315C11.9152 14.4205 12 14.6714 12 14.9387C12 15.206 11.9152 15.4572 11.7607 15.6459C11.6084 15.8318 11.3978 15.9385 11.1827 15.9385H0.817598Z",
    className: "color3Fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79489 10.9385C4.35638 10.9385 4 10.4898 4 9.93869C4 9.38725 4.35638 8.93854 4.79489 8.93854H11.2056C11.6439 8.93854 12 9.38725 12 9.93869C12 10.4898 11.6439 10.9385 11.2056 10.9385H4.79489Z",
    className: "color3Fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79489 21.9385C4.35638 21.9385 4 21.4898 4 20.9385C4 20.387 4.35638 19.9385 4.79489 19.9385H11.2056C11.4181 19.9385 11.6175 20.0425 11.7674 20.2312C11.9174 20.4202 12 20.6712 12 20.9385C12 21.2059 11.9174 21.4571 11.7674 21.6459C11.6175 21.8346 11.4181 21.9385 11.2056 21.9385H4.79489Z",
    className: "color3Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock1);
export default __webpack_public_path__ + "static/media/iconClock1.b19173fe36feb23dab4bada8b671b44f.svg";
export { ForwardRef as ReactComponent };